import * as TK from 'components/PDP/Order/RecipientForm/components/Contacts/translations/constants';

export const orderContactsCommonLocale = {
  [TK.ORDER_CONTACTS_HEADER]: 'Recipient Contact Information',
  [TK.ORDER_CONTACTS_ALERT]:
    'Please provide at least one Recipient phone number, we will use this number in case of delivery complications',
  [TK.ORDER_CONTACTS_ADD_BUTTON]: 'Home And/Or Work Phone',
  [TK.ORDER_CONTACTS_HOME_PHONE]: 'Home Phone',
  [TK.ORDER_CONTACTS_CELL_PHONE]: 'Recipient Phone*',
  [TK.ORDER_CONTACTS_WORK_PHONE]: 'Recipient Phone*',
  [TK.ORDER_CONTACTS_EMAIL_LABEL]: 'Recipient Email*',
  [TK.ORDER_DELIVERY_TEXT_MESSAGE_DISCLAIMER]:
    'By adding your mobile number you agree to receive recurring automated marketing text messages from edible at the mobile number provided. Reply HELP for help, and STOP to cancel. Message frequency varies and msg & data rate may apply.',
  [TK.ORDER_URL_DELIVERY_MESSAGE]:
    'After you place your order, we’ll give you a link to send your card to the recipient however you like.',
  [TK.MARKETPLACE_DIGITAL_CARD_DELIVERY_TITLE]:
    'How would you like to send your FREE digital card?',
  [TK.MARKETPLACE_DIGITAL_CARD_DELIVERY_BODY]:
    'Make sure the recipient’s details are correct! On completing your purchase, your digital card will be delivered to the recipient via either text or email as chosen below.',
  [TK.MARKETPLACE_DIGITAL_CARD_DELIVERY_EMAIL_ERROR]:
    'Enter a valid email address',
  [TK.MARKETPLACE_DELIVERY_DETAILS]:
    'We only contact the recipient if there are delivery complications',
};
